import { api } from '../../api/api';
import axios from 'axios';
import apiError from '../../api/api-error';
import localStorage from '../localStorage';

// initial state
const state = {
   results:null,
   isLoading:false,
   term:null,
   type:null,
   shown:false
}

// getters
const getters = {
   getSearchResultsSelected:(state) => () => {
      return localStorage.get('resultsSelected') || [];
   }
};

let prevSearchCancel;

// actions
const actions = {
   /*
   data
      query
      [bbox]
      type (parcel or permit)
      doEmptySearch (bool)
   */
   SEARCH:function(context, data){
      return new Promise((resolve, reject)=>{

         //  don't query if we have no search
         if (!data.doEmptySearch && !data.query){
            context.commit('SEARCH_LOADING_SET', false);
            context.commit('SEARCH_RESULTS_SET', []);
            resolve();
            return;
         }
         
         context.commit('SEARCH_LOADING_SET', true);
         context.commit('SEARCH_TYPE_SET', data.type);

         let path, 
            params = {
               q: data.query,
               quick: true,
            };
         if (data.type === 'permit'){
            path = '/api/search/permits';
            params.bbox = data.bbox;
            params.count = 50;
         } else {
            path = '/api/search/addresses';
         }
         //  make search request to API

         if (prevSearchCancel){
            prevSearchCancel.cancel()
         }

         prevSearchCancel = axios.CancelToken.source()

         api.get(path, {
            params: params,
            cancelToken: prevSearchCancel.token
         }).then(function (res) {
            res.data = res.data || [];
            context.commit('SEARCH_LOADING_SET', false);
            resolve(res.data); // up to the search dispatcher to format and set results
         }).catch(function (error) {
            if (error.__CANCEL__) return
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('search',error)});
            context.commit('SEARCH_LOADING_SET', false);
            reject(error);
         });     
      });
   },
   SEARCH_TERM_SET:function(context, data){
      return new Promise((resolve, reject)=>{
         context.commit('SEARCH_TERM_SET', data.term);
         resolve();
      });
   },
   SEARCH_RESULT_SELECT:function(context, data){
      return new Promise((resolve, reject)=>{
         
         // store in localStorage
         let resultsSelected = localStorage.get('resultsSelected') || [];
         let found = false;
         resultsSelected.map((result)=>{
            if (result.id === data.id){
               found = true;
            }
         });
         if (found) return resolve();

         resultsSelected.unshift(data);
         resultsSelected = resultsSelected.slice(0,3);
         localStorage.set('resultsSelected',resultsSelected);

         resolve();
      });
   },
   SEARCH_RESULTS_SET:function(context, data){
      return new Promise((resolve, reject)=>{
         context.commit('SEARCH_RESULTS_SET', data);
         resolve();
      });
   },
   SEARCH_SHOWN_SET:function(context, data){
      context.commit('SEARCH_SHOWN_SET', data);
   },
}

// mutations
const mutations = {
   SEARCH_TERM_SET: function(state, data){
      state.term = data;
   },
   SEARCH_TYPE_SET: function(state, data){
      state.type = data;
   },
   SEARCH_LOADING_SET: function(state,data){
      state.isLoading = data;
   },
   SEARCH_RESULTS_SET: function(state,data){
      state.results = data.results;
   },
   SEARCH_SHOWN_SET: function(state,data){
      state.shown = data;
   }
}

export default {
   state,
   getters,
   actions,
   mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/search.js